import { GENDERLIST_MENTOR, GENDERS, ROUTE_PATH } from "common/constants/sm-constants";
import {
  FormMetaModel,
  SmMetaInputModel,
  SmMetaSelectModel,
} from "common/models/utility-models/meta-model";

export class MentorLogsFilterMetaModel extends FormMetaModel {
  constructor() {
    super("", ROUTE_PATH.applicantGrid, "", 3);
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    const mentorGender = new SmMetaSelectModel(
      "mentorGender",
      "mentorGender",
      "select",
      false,
      "col-12 col-md-4",
      1,
      1,
      "",
      "select",
      "Select Gender",
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      "name",
      "value"
    );

    const batch_number = new SmMetaSelectModel(
      "batch_number",
      "batch_number",
      "select",
      false,
      "col-12 col-md-4",
      1,
      1,
      "",
      "select",
      "Select Batch",
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      "batch_number",
      "batch_number"
    );

    const mentorName = new SmMetaSelectModel(
      "mentorName",
      "mentorName",
      "select",
      false,
      "col-12 col-md-4",
      1,
      1,
      "",
      "select",
      "Select Mentor Name",
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      GENDERLIST_MENTOR,
      "mentor_name",
      "mentor_name"
    );

    const search = new SmMetaInputModel(
      'search',
      'search',
      'input',
      false,
      'col-12 col-md-4',
      1,
      3,
      '',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1
    );

    return {
      formInfo,
      mentorGender,
      search,
      batch_number,
      mentorName
    };
  }
}
